<template>
    <div>
        <el-carousel height="460px" style="background-color: #fff;">
            <el-carousel-item  v-for="(item, index) in sliders" :key="index">
				<div :style="{backgroundImage: 'url(' + item.img + ')'}" class="slider_img" >
					<div class="slider_img-banner">
						<img :class="index == 1 ? 'imgTit-img' : ''" :src="item.imgTit" alt="" />
						<div class="left-img-btns">
							<span @click.stop="openCode()" class="btn btn1" :class="{'blue-btn1': index == 1}">立即使用</span>
							<span @click.stop="openCode()" class="btn btn2" :class="{'blue-btn2': index == 1}">更多方案</span>
						</div>
					</div>
				</div>
            </el-carousel-item>
        </el-carousel>
		<div class="quick_wrap">
			<div class="quick_wrap-row">
				<el-row :gutter="10">
				    <el-col :xs="12" :sm="12" :md="6" v-for="(item, i) in images" :key="i">
				        <div class="border flex">
							<div class="border_img_child">
								<div class="border_num">{{item.num}}</div>
								<div class="border_title">{{item.title}}</div>
							</div>
				        </div>
				    </el-col>
				</el-row>
			</div>
		</div>
		<div class="home-intro pt-80">
			<h2 class="member-t">全流程订单管理解决方案</h2>
			<p class="member-p font-red">订单实现全流程数据记录，便于高效追踪与管理</p>
			<div class="flex quick_wrap-row">
				<div class="left">
					<div class="left-top">
						<div class="left-tab">
							<span 
								@click="orderIndex = i" 
								v-for="(item, i) in orderTab" 
								:key="i" 
								class="tab-t" 
								:class="{'active-red': orderIndex == i}">{{ item }}</span>
						</div>
						<div v-if="orderIndex == p" class="left-name" v-for="(item, p) in orderManagement" :key="p">
							<div class="name">{{ item.name }}</div>
							<div class="desc">{{ item.desc }}</div>
						</div>
					</div>
					<div class="flex">
						<p class="operate-btn operate-btn1" @click.stop="openCode()">了解更多</p>
						<p class="operate-btn" @click.stop="openCode()">立即使用</p>
					</div>
				</div>
				<img v-if="orderIndex == 0" class="left-img-order" src="../../static/home/e-contract.png" alt="" />
				<img v-if="orderIndex == 1" class="left-img-order" src="../../static/home/calculator.png" alt="" />
				<img v-if="orderIndex == 2" class="left-img-order" src="../../static/home/order-management.png" alt="" />
			</div>
		</div>
		<div class="home-intro pt-140">
			<h2 class="member-t">全方位智能管理解决方案</h2>
			<p class="member-p font-red">助力门店高效运营，降低风险，实现稳健增长</p>
			<div class="flex quick_wrap-row">
				<img v-if="abilityIndex == 0" class="right-img-order" src="../../static/home/customer-risk.png" alt="" />
				<img v-if="abilityIndex == 1" class="right-img-order" src="../../static/home/radar-services.png" alt="" />
				<img v-if="abilityIndex == 2" class="right-img-order" src="../../static/home/performance-statistics.png" alt="" />
				<div class="right">
					<div class="left-top">
						<div class="left-tab">
							<span 
								@click="abilityIndex = i" 
								v-for="(item, i) in abilityTab" 
								:key="i" 
								class="tab-t" 
								:class="{'active-red': abilityIndex == i}">{{ item }}</span>
						</div>
						<div v-if="abilityIndex == p" class="left-name right-name" v-for="(item, p) in abilityManagement" :key="p">
							<div class="name">{{ item.name }}</div>
							<div class="desc">{{ item.desc }}</div>
						</div>
					</div>
					<div class="flex">
						<p class="operate-btn operate-btn1" @click.stop="openCode()">了解更多</p>
						<p class="operate-btn" @click.stop="openCode()">立即使用</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 全场景解决方案 -->
		<div class="ability-intro pt-60">
			<h2 class="member-t">全场景解决方案</h2>
			<p class="member-p font-red mb-35">一站式管理，提升效率，驱动持续发展</p>
			<div class="ability-flex quick_wrap-row">
				<div class="ability-l">
					<img class="ability-img" src="../../static/home/ability-icon1.png" alt="" />
					<img class="ability-img" src="../../static/home/ability-icon2.png" alt="" />
					<img class="ability-img" src="../../static/home/ability-icon3.png" alt="" />
				</div>
				<div class="ability-r">
					<img class="ability-img4" src="../../static/home/ability-icon4.png" alt="" />
					<img class="ability-img5" src="../../static/home/ability-icon5.png" alt="" />
				</div>
			</div>
		</div>
		<!-- 30万+寄售行的信赖之选 -->
		<StoreImg></StoreImg>
		<div class="center-banner">
			<img class="center-img" src="../../static/home/center-banner.png" alt="" />
			<div class="banner-img flex">
				<img class="center-banner-t" src="../../static/home/center-banner-t1.png" alt="" />
				<div class="trial-btn" @click.stop="openCode()">立即咨询</div>
			</div>
		</div>
		<!-- 商户saas -->
		<Saas :flag="'1'"></Saas>
		<!-- 全程陪伴服务体系 -->
		<Service></Service>
		<div style="background-color: #fff;">
			<div class="download flex">
				<div class="download-l flex-1">云当铺·寄售行业新引擎</div>
				<div class="download-r">
					<div class="download-r-item android">
						<img class="android-img" src="../../static/home/android.png" alt="" />
						<img class="android-code" src="../../static/home/android-code.png" alt="" />
						<P class="android-code1">安卓</P>
					</div>
					<div class="download-r-item apple">
						<img class="apple-img" src="../../static/home/ios.png" alt="" />
						<img class="apple-code" src="../../static/home/ios-code.png" alt="" />
						<P class="apple-code1">ios</P>
					</div>
					<div class="download-r-item wx">
						<img class="wx-img" src="../../static/home/wx.png" alt="" />
						<img class="wx-code" src="../../static/home/wx-code.png" alt="" />
						<P class="wx-code1">小程序</P>
					</div>
				</div>
			</div>
		</div>
		<ConsultDialog v-if="centerDialogVisible" @close="close"></ConsultDialog>
    </div>
</template>
<script>
	import ConsultDialog from './ConsultDialog.vue'
    import { encryptLong, syShopSign } from '@/utils/rsaEncrypt'
    export default {
        name: 'Index',
		components: {ConsultDialog},
        data() {
            return {
				centerDialogVisible: false,
                // 容器的高度
                bannerHeight:0,
                // 瀏覽器寬度
                screeWith:0,
                sliders: [],
                images: [
                    {
                        num: "行业标杆",
                        title: '引领寄售行业新模式，全面数字化管理，提升门店效率与盈利能力'
                    },
                    {
                        num: "高效省心",
                        title: '全流程线上管理，自动化管理订单和库存，提升效率'
                    },
                    {
                        num: "安全可靠",
                        title: '数据加密存储，隐私合规保障，交易安全无忧'
                    }, 
					{
                       num: "持续升级",
                       title: '功能迭代快，智能管理持续优化，助力门店发展'
                    },
                ],
                spec: {
                    img: require('../../static/other/arrow.png'),
                    product: [
                        {
                            img: require('../../static/other/手指.png'),
                            title: "一键操作",
                            contents: ["一键延期或买回", "操作方便快捷安全"]
                        },
                        {
                            img: require('../../static/other/店铺管理.png'),
                            title: "一键延期",
                            contents: ["系统实时监控寄售状态", "自动检测延期金额和差价"]
                        },
                        {
                            img: require('../../static/other/用户构建.png'),
                            title: "一键买回",
                            contents: ["校验买回码", "支付买回费用"]
                        },
                        {
                            img: require('../../static/other/助力零售.png'),
                            title: "平台核查",
                            contents: ["检测师核对买回信息", "顺丰发货业务灵活方便"]
                        }
                    ]
                },
                company: [
                    "云当铺”诚信为本,厚德载物”。实时提供手机、平板、相机、笔记本、首饰、包包、奢侈品等便捷、安全寄售信息服务平台！",
                    "[线上线下]线下专人上门办理、线下全国包邮办理。",
                    "[高价回收]专业检测师验机全，回收价格高于其它网站。",
                    "[可选备机]针对仅有一台手机寄售者可提供智能产品备用。",
                    "[快速买回]用户提交买回时，专业客服第一时间办理。",
                    "[全民优惠]无论新用户或老用户都有优惠，可并存。订单自动计算。",
                ],
                memberList1: [
					{name: '门店品牌加持', title: ''},
					{name: '估价系统', title: '1次/日'},
					{name: '合同立项', title: '5单/月'},
					{name: '订单管理', title: ''},
					{name: '财务审批', title: ''},
					{name: '智能计算器', title: ''},
					{name: '云铺商城', title: ''},
					{name: '订单资料云储存', title: ''},
					{name: '线上交易服务费1%', title: ''},
				],
				memberList2: [
					{name: '到期自动提醒服务', title: ''},
					{name: '逾期警示提醒服务', title: ''},
					{name: '销售时机提醒服务', title: ''},
					{name: '转回收业务提醒服务', title: ''},
					{name: '客户信用风险', title: ''},
					{name: '多端登录', title: ''},
					{name: '线上交易服务费1%', title: ''},
				],
				memberList3: [
					{name: '团队业绩报表', title: ''},
					{name: '综合资产管理', title: ''},
					{name: '智能仓库管理', title: ''},
					{name: '业绩排行榜', title: ''},
					{name: '物流追踪', title: ''},
					{name: '优惠券', title: ''},
					{name: '智能化获客代运营', title: ''},
					{name: '线上交易服务费1%', title: ''},
				],
				memberList4: [
					{name: '专业汽车业务系统服务', title: ''},
					{name: '全品类上游资源服务', title: ''},
					{name: '财务报表', title: ''},
					{name: '优质售后服务保障', title: ''},
					{name: '个性化模块定制服务', title: ''},
					{name: '产品业务培训', title: ''},
					{name: '智能匹配就近客户', title: ''},
					{name: '线上交易服务费0.6%', title: ''},
				],
				orderTab: ['电子合同','智能计算器','订单管理'],
				orderManagement: [
					{name: '电子合同', desc: '合同全流程数字化管理，实现安全存储、秒级检索与高效协同，彻底告别纸质合同带来的低效、繁琐与风险'},
					{name: '系统智能计算器', desc: '全版本自动拆解综合费、服务费等明细，费用透明可追溯，从源头减少客户纠纷'},
					{name: '订单管理', desc: '订单状态实时追踪，从业务办理到回款入账全程透明可视化，帮助管理者随时掌握最新进度与业务状态'},
				],
				abilityTab: ['客户风险','雷达提醒','业绩统计'],
				abilityManagement: [
					{name: '客户风险查询', desc: '通过身份校验与风险标签体系，对客户进行精准识别与分级。自动匹配身份证与姓名核验真实性，并基于历史行为、信用情况赋予风险标签'},
					{name: '到期、逾期、转回收提醒', desc: '智能监控物品状态，到期系统自动预警，并通过小程序、APP、短信等多渠道提醒，确保业务高效衔接，有效规避逾期风险'},
					{name: '团队业绩统计', desc: '自动生成业绩报表，直观呈现订单数量、业绩金额额、提成与逾期率，多维度数据一目了然，助力精准管理与绩效提升'},
				],
				orderIndex: 0,
				abilityIndex: 0,
				storeImgArr1: [
					require('../../static/home/store-icon1.png'),
					require('../../static/home/store-icon2.png'),
					require('../../static/home/store-icon3.png'),
					require('../../static/home/store-icon4.png'),
					require('../../static/home/store-icon5.png'),
				],
				storeImgArr2: [
					require('../../static/home/store-icon6.png'),
					require('../../static/home/store-icon7.png'),
					require('../../static/home/store-icon8.png'),
					require('../../static/home/store-icon9.png'),
					require('../../static/home/store-icon10.png'),
				]
            }
        },
        methods: {
			close(flag) {
				this.centerDialogVisible = false
			},
			openCode() {
				this.centerDialogVisible = true
			},
            getOpenMinChengXuLink() {
                if (this.isMobile()) {
                    let url = '/sy/aboutUs/getScheme';
                    const timeStamp = new Date().getTime();
                    const sySign = syShopSign();
                    const CheckCsrf = encryptLong(sySign + timeStamp);
                    this.axios.get(url,{headers:{'TimeStamp': timeStamp, 'CheckCsrf': CheckCsrf,'Content-Type':'application/x-www-form-urlencoded'}}).then(res => {
                        location.href = res.data.data;   
                    })
                } else {
                    console.log('pc端不跳转')
                    return;
             }
                
            },
            // 判断是否是手机端，如果是，返回true
            isMobile () {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag
            }
        },
        mounted() {
            this.sliders = [
                {
                    img: require('../../static/home/1banner.png'),
					imgTit: require('../../static/home/top-banner1-t.png')
                },
				{
				    img: require('../../static/home/2banner.png'),
					imgTit: require('../../static/home/top-banner2-t.png')
				},
            ],
            // 首次加載時，初始化高度
            this.screeWith = window.innerWidth
            this.bannerHeight = 560/1920*this.screeWith
			// 窗口大小發生變化
			window.onresize=()=>{
				this.screeWith=window.innerWidth
				this.bannerHeight = 560/1920*this.screeWith
			}
        },
        computed: {
            //计算高度
            // computeHeight() {
            //     let screenHeight = document.body.clientWidth;
            //     if (screenHeight > 415) {
            //         return '550px';
            //     } else {
            //         return '250px';
            //     }
            // },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
    }
</script>

<style scoped>
    /* 清除banner滾動條 */
    .el-carousel--horizontal {
        overflow-x: hidden;
        overflow-y: hidden;
    }
    .el-carousel__indicator.is-active{
        border-bottom: 2px solid #ff717b !important;
    }
    _parent {
        width: 90%;
        margin: auto;
    }
	.banner-item {
		position: relative;
	}
	.left-img-btns {
		margin-top: 20px;
	}
	.btn {
		display: inline-block;
		width: 200px;
		height: 50px;
		line-height: 50px;
		border-radius: 30px;
		text-align: center;
		font-weight: 500;
		font-size: 20px;
		cursor: pointer;
	}
	.btn1 {
		color: #FFFFFF;
		background: #FE3D3A;
		box-shadow: 0px 12px 20px 0px rgba(254,61,58,0.15);
		margin-right: 20px;
	}
	.btn2 {
		color: #FE3D3A;
		border: 1px solid #FE3D3A;
	}
	.blue-btn1 {
		background: #767FFD;
		box-shadow: 0px 12px 20px 0px rgba(50,118,251,0.15);
	}
	.blue-btn2 {
		border: none;
		color: #767FFD;
		border: 1px solid #767FFD;
	}
    .slider_img {
		height: 460px;
		background-size: auto 100%;
		background-repeat: no-repeat;
		background-position: center center;
    }
	.slider_img-banner {
		width: 1200px;
		margin: 0 auto;
		position: relative;
	}
	.slider_img .slider_img-banner img {
		width: 430px;
		height: 201px;
		margin-top: 100px;
	}
	.slider_img .slider_img-banner .imgTit-img {
		width: 453px;
		height: 228px;
		margin-top: 60px;
	}
	.quick_wrap {
		background-color: #fff;
	}
	.quick_wrap-row {
		width: 1200px;
		margin: 0 auto;
	}
	.img_border {
		width: 60px;
		height: 60px;
	}
	.border_img_child {
		flex: 1;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: center;
		margin-right: 20px;
		padding: 35px 26px 27px;
		box-shadow: 0px 0px 25px 0px rgba(232,232,232,0.5);
		border-radius: 0px 0px 10px 10px;
		cursor: pointer;
	}
	.border_img_child:last-child {
		margin-right: 0;
	}
	.border_img_child:hover {
		border-top: 5px solid #FE3D3A;
		padding-top: 30px;
	}
	.border_img_child:hover .border_num {
		color: #FE3D3A;
	}
	.border_num {
		font-weight: 600;
		font-size: 28px;
		color: #333333;
	}
	.border_title {
		font-size: 14px;
		color: #666666;
		text-align: center;
	}
	.home-intro {
		background-color: #fff;
	}
	.left-img {
		width: 560px;
		height: 560px;
	}
	.left-img-order {
		width: 600px;
		height: 339px;
	}
	.right-img-order {
		width: 600px;
		height: 520px;
	}
	.quick_wrap-row .right {
		margin-left: 102px;
		flex: 1;
	}
	.quick_wrap-row .left {
		margin-right: 186px;
		flex: 1;
	}
	.quick_wrap-row .right {
		margin-left: 186px;
		flex: 1;
	}
	.quick_wrap-row .left-top .left-tab {
		font-size: 18px;
		color: #999999;
		border-bottom: 1px solid #F2F2F2;
		display: flex;
		align-items: center;
	}
	.quick_wrap-row .left-top .left-tab .tab-t {
		display: inline-block;
		padding-bottom: 12px;
		margin-right: 89px;
		cursor: pointer;
	}
	.quick_wrap-row .left-top .left-tab .tab-t:last-child {
		margin-right: 0px;
	}
	.left-name {
		padding-top: 50px;
		padding-bottom: 20px;
	}
	.right-name .desc {
		height: 130px;
	}
	.left-name .name {
		font-weight: 600;
		font-size: 26px;
		color: #333333;
	}
	.left-name .desc {
		font-size: 14px;
		color: #666666;
		padding-top: 20px;
		line-height: 2.5;
	}
	.active-red {
		font-weight: 600;
		color: #FE3D3A;
		border-bottom: 2px solid #FE3D3A;
	}
	.ability-intro {
		background: linear-gradient( 180deg, #FFEDED 0%, #FFFAFA 100%);
		box-shadow: 0px -3px 23px 0px rgba(166,167,171,0);
	} 
	.ability-flex {
		display: flex;
		align-items: center;
		padding-bottom: 60px;
	}
	.ability-l {
		width: 640px;
		margin-right: 20px;
	}
	.ability-r {
		width: 540px;
	}
	.ability-img {
		width: 640px;
		height: 278px;
		margin-bottom: 20px;
		vertical-align: middle;
		border-radius: 15px; 
		cursor: pointer;
		transition: transform 0.3s ease; 
	}
	.ability-img:last-child {
		margin-bottom: 0;
	}
	.ability-img4 {
		width: 540px;
		height: 278px;
		margin-bottom: 20px;
		vertical-align: middle;
		border-radius: 15px; 
		cursor: pointer;
		transition: transform 0.3s ease; 
	}
	.ability-img5 {
		width: 540px;
		height: 576px;
		vertical-align: middle;
		border-radius: 15px; 
		cursor: pointer;
		transition: transform 0.3s ease; 
	}
	.ability-img:hover {
		transform: scale(1.04); 
		box-shadow: 0 10px 15px rgba(170,69,67,0.1);
	}
	.ability-img4:hover,
	.ability-img5:hover {
		transform: scale(1.04);
		box-shadow: 0 10px 15px rgba(170,69,67,0.1);
	}
	.store-row {
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}
	.store-row .store-img {
		flex: 1;
		height: 224px;
		margin-right: 20px;
		vertical-align: middle;
		cursor: pointer;
		transition: transform 0.3s ease; 
	}
	.store-row1 {
		margin-bottom: 0;    
		padding-bottom: 60px;
	}
	.store-row1 .store-img {
		mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0)); /* 从不透明到透明的渐变 */
		-webkit-mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0)); /* Safari浏览器兼容性 */
	}
	.store-row .store-img:hover {
		transform: scale(1.08);
		-webkit-mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,1));
		mask-image: linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,1));
	}
	.h3-t {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
	}
	.p-desc {
		font-weight: 600;
		font-size: 12px;
		font-size: 12px;
		color: #999999;
		padding-top: 15px;
		padding-bottom: 30px;
	}
	.q-item {
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		display: flex;
		align-items: center;
		margin-bottom: 30px;
	}
	.q-item .question-img {
		width: 23px;
		height: 30px;
		margin-right: 8px;
	}
	.operate-btn {
		width: 200px;
		height: 50px;
		line-height: 50px;
		border-radius: 30px;
		border: 1px solid #FE3D3A;
		font-weight: 500;
		font-size: 20px;
		color: #FE3D3A;
		text-align: center;
		margin-top: 10px;
		cursor: pointer;
	}
	.operate-btn1 {
		color: #fff;
		margin-right: 20px;
		background: #FE3D3A;
		box-shadow: 0px 12px 20px 0px rgba(254,61,58,0.15);
	}
	.center-banner {
		height: 223px;
		position: relative;
	}
	.banner-img {
		width: 1200px;
		margin: 0 auto;
		position: absolute;
		left: 0;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		z-index: 10;
	}
	.center-img {
		width: 100%;
		height: 223px;
	}
	.center-banner-t {
		width: 802px;
		height: 107px;
		margin-right: 146px;
	}
	.trial-btn {
		display: inline-block;
		width: 252px;
		height: 63px;
		line-height: 63px;
		background: #FFFFFF;
		border-radius: 32px;
		border: 1px solid #FFFFFF;
		font-weight: 600;
		font-size: 20px;
		color: #963826;
		text-align: center;
		cursor: pointer;
	}
	.service-row {
		display: flex;
		align-items: center;
		cursor: pointer;
	}
	.service-row-l {
		width: 360px;
		margin-right: 20px;
	}
	.service-row-l img {
		width: 360px;
		height: 500px;
		vertical-align: middle;
		border-radius: 15px;
		transition: transform 0.3s ease; 
	}
	.service-row-l img:hover {
		transform: scale(1.04);
		box-shadow: 0 10px 15px rgba(170,69,67,0.1);
	}
	.service-row-r {
		flex: 1;
	}
	.service-row-r .service-row-img {
		width: 400px;
		height: 240px;
		vertical-align: middle;
		border-radius: 15px;
		transition: transform 0.3s ease; 
	}
	.service-row-r .service-row-img:hover {
		transform: scale(1.04);
		box-shadow: 0 10px 15px rgba(170,69,67,0.1);
	}
	.member {
		width: 1200px;
		margin: 0 auto;
		margin-top: 100px;
		margin-bottom: 15px;
		padding-bottom: 70px;
	}
	.member-t {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		text-align: center;
	}
	.member-p {
		font-weight: 600;
		font-size: 14px;
		color: #999999;
		margin-bottom: 80px;
		text-align: center;
	}
	.service-fee {
		font-size: 14px;
		color: #666666;
		margin-left: 27px;
	}
	.download {
		width: 1200px;
		margin: 0 auto;
		padding: 30px 0;
	}
	.download-l {
		font-weight: 600;
		font-size: 40px;
		color: #FE3D3A;
	}
	.download-r {
		display: flex;
		align-items: center;
	}
	.download-r-item {
		text-align: center;
		font-weight: 600;
		font-size: 14px;
		color: #FE3D3A;
		margin-left: 100px;
		cursor: pointer;
		position: relative;
	}
	.download-r-item img {
		width: 110px;
		height: 110px;
	}
	.download-r-item p {
		margin-top: 5px;
		position: absolute;
		bottom: -26px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 99;
	}
	.wx-code {
		display: none;
	}
	.wx-code1 {
		opacity: 0;
	}
	.wx:hover .wx-img {
		display: none;
	}
	.wx:hover .wx-code {
		display: block;
	}
	.wx:hover .wx-code1 {
		opacity: 1;
	}
	.android-code {
		display: none;
	}
	.android-code1 {
		opacity: 0;
	}
	.android:hover .android-img {
		display: none;
	}
	.android:hover .android-code {
		display: block;
	}
	.android:hover .android-code1 {
		opacity: 1;
	}
	.apple-code {
		display: none;
	}
	.apple-code1 {
		opacity: 0;
	}
	.apple:hover .apple-img {
		display: none;
	}
	.apple:hover .apple-code {
		display: block;
	}
	.apple:hover .apple-code1 {
		opacity: 1;
	}
    
    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 250px;
            width: 100%;
        }


        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0;

        }

        .product_mobile {
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 15px;
        }

        .product_mobile_content_one {
            margin-top: 5px;
        }

        .product_mobile_content_two {
            margin-top: 5px;
        }

        .product_mobile_img_div {
            display: flex;
            width: 100%;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .product_mobile_img {
            float: left;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25rem;
        }

        .product_font_style {
            font-size: 1rem;
        }

        .product_pc_img {
            height: 280px;
            width: 320px;
        }

        .product_pc_img_div {
            width: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        .product_pc {
            display: flex;
            width: 90%;
            height: auto;
            margin: 20px auto;
            background: #F2F6FC;
            flex-direction: column;
        }

        .head-label {
            display: flex;
            margin-top: 10px;
        }

        .product_spec_parent {
            display: flex;
            width: 90%;
            align-items: center;
            justify-content: center;
            margin: 20px auto;
            height: auto;
            flex-direction: column;
        }

        .border_spec {
            float: left;
            height: auto;
            margin: 8px;
            width: 100%;
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }


        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125rem;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125rem;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125rem;
            margin-bottom: 8px;
        }

        .img_border {
            margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .border_spec_inner_one {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 8px;
            /*background-color: aqua;*/
            height: 70px;
        }

        .border_spec_content_one {
            margin-top: 5px;
            font-size: 1.125rem;
            float: left;
        }

        .border_spec_inner_last {
            /*background-color: bisque;*/
            margin-top: 5px;
            font-size: 1.125rem;
            float: left;
            margin-bottom: 8px;
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            width: 100%;
        }
    }

    .border_spec_img {
        width: 75px;
        height: 55px;
        align-self: center
    }

    .font_size_24 {
        font-size: 1.5rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/Index.vue